import { DateTime, Settings } from 'luxon';
import { AvailableAppointmentTimeString } from '../appointment-datetime';

export const availableTimezones = [
  'Australia/Perth',
  'Australia/Eucla',
  'Australia/Darwin',
  'Australia/Brisbane',
  'Australia/Adelaide',
  'Australia/Sydney',
  'Australia/Lord_Howe',
];

export const getDefaultTimezone = () => {
  const timezone = Settings.defaultZoneName;
  return availableTimezones.includes(timezone) ? timezone : 'Australia/Sydney';
};

export const getTimezoneLabel = (timezone: string) => {
  const zoneName = timezone?.split('/')[1];
  let output;
  switch (zoneName) {
    case 'Sydney':
      output = 'Sydney / Melbourne';
      break;
    case 'Lord_Howe':
      output = 'Lord Howe Island';
      break;
    default:
      output = zoneName;
  }
  return `${output} Time`;
};

export const getTimezoneAbbr = (timezone: string) => {
  const offsetName = DateTime.fromISO(DateTime.local().toISO(), { zone: timezone }).offsetNameLong;
  return offsetName
    .split(' ')
    .map((i) => i[0])
    .join('');
};

export const convertAppointmentTimezone = (
  availableTimeStrings: AvailableAppointmentTimeString[],
  timezone: string,
  filterOutFifteenMinuteTimeslots: boolean = false
) => {
  const convertedAvailability = availableTimeStrings?.map((availableTimeString) => ({
    ...availableTimeString,
    datetime: DateTime.fromISO(availableTimeString.datetime, { zone: timezone }).toISO(),
  }));

  return filterOutFifteenMinuteTimeslots
    ? convertedAvailability.filter(
        (availableTimeString) =>
          ![15, 45].includes(DateTime.fromISO(availableTimeString.datetime, { zone: timezone }).minute)
      )
    : convertedAvailability;
};
